import { render } from "./CardsFrame.vue?vue&type=template&id=39908a81"
import script from "./CardsFrame.vue?vue&type=script&lang=js"
export * from "./CardsFrame.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__